import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { enumProviderType } from 'src/app/models/commos/enum-provider-type';
import { RentalOrder } from 'src/app/models/rental/rental-order';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { CombosConfiguration, FunctionsService, HttpService, MessageService, params, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { Provider } from 'src/app/models/administration/provider';
import { EquipmentRental } from 'src/app/models/rental/equipment-rental';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';

@Component({
    selector: 'app-details-rental-order',
    templateUrl: './details-rental-order.component.html',
    styleUrls: ['./details-rental-order.component.scss'],
    standalone: false
})
export class DetailsRentalOrderComponent implements OnInit, OnDestroy {

  @ViewChild('stepper') stepper: MatStepper;
  @Input() showTableRentalEquipment: boolean = false;
  @Input() showEditForm: boolean = false;
  @Output() completeOrder = new EventEmitter<any>();

  public isDisabled: boolean = false;
  public disbledEquipment: boolean = false
  public EndpointDictionary = EndpointDictionary;

  public urlGetEquipmentRental: string = `${EndpointDictionary.EquipmentRental.EQUIPMENT_EQUIPMENT_RENTAL_COMBO}`;
  public itemsData: InputOrOutputInventory[] = []

  public paramsProvider: params[] = [{ id: 'providerTypeId', value: enumProviderType.CLIENTE }];
  public paramsRentalOrder: params[] = [{ id: 'stateId', value: 0 }];
  public paramsEquipmentRental: params[] = [{ id: 'rentalId', value: '0' }]

  public data:any
  public rentalOrder: RentalOrder = null
  public rentalOrderState: number = 0
  public formEquipmentRental: FormGroup
  public formRO: FormGroup
  public movil
  public buttonActive: boolean = false
  private providerId: number
  private dataComboProviders: Provider[] = []

  public reloadComboDelivery = new EventEmitter<any>()
  public combosConfigDelivery: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: EndpointDictionary.User.USER_COMBO,
    urlParams: [],
    label: 'Entregado por',
    selected: 0
  }

  public reloadComboReceives = new EventEmitter<any>()
  public combosConfigReceives: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: EndpointDictionary.User.USER_COMBO,
    urlParams: [],
    label: 'Recogido por',
    selected: 0
  }

  public reloadComboClient = new EventEmitter<any>()
  public combosConfigClient: CombosConfiguration = {
    visibleField: 'providerName',
    selectionField: 'id',
    urlCombo: EndpointDictionary.Provider.PROVIDER_TYPE_COMBO,
    urlParams: this.paramsProvider,
    label: 'Cliente',
    selected: 0
  }

  // tabla orden alquiler
  public reloadEquipmentRental = new EventEmitter<any>();
  public configurationEquipmentRental: TableConfiguration = {
    add: true,
    delete: true,
    selectable: true,
    primaryKey: 'id',
  };
  public columnsEquipmentRental: TableColumns<EquipmentRental>[] = [
    {
      ID: 'equipmentCode',
      label: 'Codigo',
      type: 'combo',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'itemName',
        url: `${EndpointDictionary.EquipmentRental.EQUIPMENT_EQUIPMENT_RENTAL_COMBO}`,
        returnDataSelect:true
      }
    },
    {
      ID: 'rentalCost',
      label: 'Costo Rental',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
      disregardForAdd: true
    },
    {
      ID:'equipmentName',
      label:'Marca',
      type:'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
      disregardForAdd: true
    }
];

  constructor(
    private http: HttpService,
    private session: SessionService,
    private formBuilder: FormBuilder,
    private message: MessageService,
    private functionEter: FunctionsService,
    private utils: UtilsServiceService
  ) {
    this.data = this.session.getData('data')
    this.formRO = this.formBuilder.group({
      providerId: '',
      userDeliveryId: '',
      userReceivesId: '',
      stateId: '',
      providerAddress: '',
      comment: '',
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
    }),
      this.formEquipmentRental = this.formBuilder.group({

      })

  }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
    if (this.data.action == 'edit') {
      this.startFields()

    if(this.rentalOrder && this.rentalOrder.stateId != 1){
      this.disbledEquipment = true;
    }

    if(this.rentalOrder && this.rentalOrder.stateId == 5){
      this.isDisabled = true
      this.formRO.get('providerAddress').disable()
      this.formRO.get('comment').disable()
    }

    if (this.rentalOrder.stateId == 3 || this.rentalOrder.stateId == 4 ) {
      this.formRO.get('providerAddress').disable()
    }
   }
  }

  ngOnDestroy() {
    this.session.setData('data', null)
  }

  async startFields() {
    this.rentalOrder = this.data.body[0]
    this.rentalOrderState = this.rentalOrder.stateId
    this.paramsEquipmentRental = [{ id: 'rentalId', value: this.rentalOrder.id }]

    for (let controls of Object.keys(this.formRO.controls)) {
      if (this.rentalOrder[controls]) {
        this.formRO.get(controls).setValue(this.rentalOrder[controls])
      }
    }

    this.itemsData = this.rentalOrder.equipments.map((element) => {
      let item: InputOrOutputInventory = {
        itemInventoryId: element.equipmentId,
        costItem: element.rentalCost,
        totalCost: element.rentalCost,
        code: element.equipmentCode,
        amount: 1,
        itemName: element.equipmentName
      }
      return item
    })
    this.formRO.get('startTime').setValue(this.utils.extractTime(this.rentalOrder.startDate))
    this.formRO.get('endTime').setValue(this.utils.extractTime(this.rentalOrder.endDate))


    let fecha = this.utils.handlerDateToIsoString(this.rentalOrder.startDate)
    this.formRO.get('startDate').setValue(this.utils.handlerDateToIsoString(this.rentalOrder.startDate))
    this.formRO.get('endDate').setValue(this.utils.handlerDateToIsoString(this.rentalOrder.endDate))
  }

  async saveRO(rentalOrder?: RentalOrder) {
    if (this.data.action == 'add') {
     await this.http.postDataBody(`${EndpointDictionary.RentalOrder.CRUD_RENTAL_ORDER}`, rentalOrder)
    } else {
      delete rentalOrder.startTime
      delete rentalOrder.endTime
      rentalOrder.id = this.rentalOrder.id
      await this.http.putDataBody(`${EndpointDictionary.RentalOrder.CRUD_RENTAL_ORDER}`, rentalOrder)
    }
    setTimeout(() => {
      this.completeOrder.emit()
    }, 500);
  }

  async getROFromForm(): Promise<any> {
    return {
      providerId: this.formRO.get('providerId').value,
      providerAddress: this.formRO.get('providerAddress').value,
      userDeliveryId: this.formRO.get('userDeliveryId').value,
      userReceivesId: this.formRO.get('userReceivesId').value,
      stateId: this.rentalOrder ? this.rentalOrder.stateId : 1,
      comment: this.formRO.get('comment').value,
      startDate: this.functionEter.dateForm(this.formRO.get('startDate').value),
      startTime: this.formRO.get('startTime').value,
      endDate: this.functionEter.dateForm(this.formRO.get('endDate').value),
      endTime: this.formRO.get('endTime').value
    }
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos')
  }

  async saveRentalEquipment($event?: HistoryInventory) {
    try {
      this.message.openLoading('Cargando', 'Guardando Orden de alquiler')
      let rentalOrder: RentalOrder = await this.getROFromForm()
      rentalOrder.startDate = this.utils.formatDateTime(rentalOrder.startDate, rentalOrder.startTime)
      rentalOrder.endDate = this.utils.formatDateTime(rentalOrder.endDate, rentalOrder.endTime)
      if ($event) {
        let equipmentsRental = $event.items.map((item) => {
          return {
            equipmentId: item.itemInventoryId,
            rentalCost: item.costItem
          }
        })
        rentalOrder.equipments = equipmentsRental
      }
      await this.saveRO(rentalOrder)
      this.message.closeLoading()
      this.message.SuccessToast(`Orden de alquiler guardada`)

    } catch (error) {
      this.message.Error("Error", "Error guardando orden de alquiler")
    }
    this.message.closeLoading()
  }

  async deleteEquipmentRental($event: EquipmentRental) {
    console.log($event)
  }

  async addEquipmentRental($event: any){
    console.log($event)
    let body: EquipmentRental = {
      equipmentId: $event.equipmentCodeCombo.id,
      rentalCost: $event.equipmentCodeCombo.costItem,
      rentalId: this.rentalOrder.id
    }
    console.log(body)
  }

  getDataComboProviders($event: Provider[]) {
    this.dataComboProviders = $event
  }

  ValueIDProvider($event: number){
    if ($event && $event > 0) {
      //this.formRO.get('providerId').setValue($event)
      this.providerId = $event
    }
    const selectedProvider = this.dataComboProviders.find(provider => provider.id === this.providerId);

    if (selectedProvider) {
      this.formRO.get('providerAddress').setValue(selectedProvider.address || '');
    }
  }



}
